module.exports = __webpack_public_path__ + "static/media/5ed7a27f72f4e5e57a748788.0f2684bc.png";